// Logo and Profile Images
export const HEADER_LOGO = require("@src/assets/images/vincense-header-logo.png");
export const PROFILE = require("@src/assets/images/profile-img.jpg");
export const SIDEBAR_IMAGE = require("@src/assets/images/sidebar-image.png");
export const USER_PROFILE = require("@src/assets/images/user-profile.jpeg");
export const ORGANIZATION = require("@src/assets/images/organization-logo.png");
export const HEART_IMAGE = require("@src/assets/images/heart-image.png");
export const BP_ICON = require("@src/assets/images/devices/settings-bp-icon.png");
export const GLUCO_ICON = require("@src/assets/images/devices/settings-gluco-icon.png");
export const ECG_ICON = require("@src/assets/images/devices/settings-ecg-icon.png");
export const VINCENSE_ICON = require("@src/assets/images/devices/settings-vincense-icon.png");
export const WEIGHT_ICON = require("@src/assets/images/devices/settings-weight-icon.png");
export const ISH_LEADS = require("@src/assets/images/ish-leads.png");
